export default "__VITE_ASSET__REafulR8__"